
export default {
    props: {
        variant: { type: String, default: 'info' },
        title: { type: String, default: null },
        icon: { type: String, default: null },
    },
    computed: {
        iconName () {
            if (this.icon) { return this.icon }
            return { info: 'info-circle', warm: 'exclamation-triangle', success: 'check' }[this.variant]
        },
    },
}
